import { Box, CircularProgress, SxProps } from '@mui/material';

export default function Loading({ sx = {} }: { sx?: SxProps }) {
    return (
        <Box
            aria-label="Loading..."
            sx={{
                marginTop: 4,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}>
            <CircularProgress />
        </Box>
    );
}
